import { Box, Typography } from '@mui/material';
import gameFormatService from '../../features/gameFormat/gameFormatService';

// Renders a value in blue when it was overridden for this event/game.
const OverriddenValue = ({ field, gameFormat, children }) => {
  const isOverridden =
    Array.isArray(gameFormat?.overriddenFields) && gameFormat.overriddenFields.includes(field);

  return isOverridden ? (
    <Box component="span" sx={{ color: 'primary.main', fontWeight: 600 }}>
      {children}
    </Box>
  ) : (
    <>{children}</>
  );
};

const GameFormatDescription = ({ gameFormat }) => {
  return (
    <Box>
      <Typography variant="h5" color={'primary'}>
        {gameFormat.name}
      </Typography>
      <Typography variant="body1">
        Game Type:{' '}
        <OverriddenValue field="gameType" gameFormat={gameFormat}>
          {gameFormatService.getGameTypeString(gameFormat.gameType)}
        </OverriddenValue>
      </Typography>

      <Typography variant="body1">
        Ends Total:{' '}
        <OverriddenValue field="totalEnds" gameFormat={gameFormat}>
          {gameFormat.totalEnds || 0}
        </OverriddenValue>
      </Typography>

      <Typography variant="body1">
        Ends:{' '}
        <OverriddenValue field="ends" gameFormat={gameFormat}>
          {gameFormat.ends === 0 ? 'N/A' : gameFormat.ends}
        </OverriddenValue>
      </Typography>

      {gameFormat.extraEndGamePoint > 0 ? (
        <Typography variant="body1">
          Per-End Bonus Point:{' '}
          <OverriddenValue field="extraEndGamePoint" gameFormat={gameFormat}>
            {gameFormat.extraEndGamePoint}
          </OverriddenValue>
        </Typography>
      ) : null}

      <Typography variant="body1">
        Max Score:{' '}
        <OverriddenValue field="maxScore" gameFormat={gameFormat}>
          {gameFormat.maxScore}
        </OverriddenValue>
      </Typography>
      <Typography variant="body1">
        Include Handicap:{' '}
        <OverriddenValue field="includeHandicap" gameFormat={gameFormat}>
          {gameFormat.includeHandicap ? 'Yes' : 'No'}
        </OverriddenValue>
      </Typography>

      <Typography variant="body1">
        <OverriddenValue field="setAsSkin" gameFormat={gameFormat}>
          {gameFormat.setAsSkin ? 'Sets as Skins' : 'Sets'}
        </OverriddenValue>
        :{' '}
        <OverriddenValue field="sets" gameFormat={gameFormat}>
          {gameFormat.sets}
        </OverriddenValue>
      </Typography>
      <Typography variant="body1">
        Rounds:{' '}
        <OverriddenValue field="rounds" gameFormat={gameFormat}>
          {gameFormat.rounds}
        </OverriddenValue>
      </Typography>
      <Typography variant="body1">
        Max Point Per Set:{' '}
        <OverriddenValue field="maxTotalPerSet" gameFormat={gameFormat}>
          {gameFormat.maxTotalPerSet}
        </OverriddenValue>
      </Typography>

      <Typography variant="body1">
        Number of Bowls:{' '}
        <OverriddenValue field="numBowls" gameFormat={gameFormat}>
          {gameFormat.numBowls}
        </OverriddenValue>
      </Typography>
      <Typography variant="body1">
        Tiebreaker:{' '}
        <OverriddenValue field="playoffs" gameFormat={gameFormat}>
          {gameFormat.playoffs ? 'Yes' : 'No'}
        </OverriddenValue>
      </Typography>

      {gameFormat.playoffs && (
        <>
          <Typography variant="body1">
            Tiebreaker Max Points:{' '}
            <OverriddenValue field="playoffMaxPoints" gameFormat={gameFormat}>
              {gameFormat.playoffMaxPoints}
            </OverriddenValue>
          </Typography>
          <Typography variant="body1">
            Tiebreaker Point:{' '}
            <OverriddenValue field="playoffPoint" gameFormat={gameFormat}>
              {gameFormat.playoffPoint}
            </OverriddenValue>
          </Typography>
        </>
      )}

      {gameFormat.multiplier > 1 && (
        <Typography variant="body1">
          Multiplier:{' '}
          <OverriddenValue field="multiplier" gameFormat={gameFormat}>
            {gameFormat.multiplier}x
          </OverriddenValue>
        </Typography>
      )}
    </Box>
  );
};

export default GameFormatDescription;
